<template>
  <customer-registration-form />
</template>

<script>
import CustomerRegistrationForm from "@/components/3pl/CRM/CustomerRegistration/CustomerRegistrationForm";
export default {
  components: {
    CustomerRegistrationForm,
  },
};
</script>

<style></style>
